module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_row_3.7549e168.png";